import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import EpisodePopup from "@COMPONENTS/product/common/popup/desktop/EpisodePopup";
import * as style from "@COMPONENTS/style/detailpackage/reviews";
import useReviewEpisode from "@QUERIES/prdt/review/useReviewEpisode";
import dayjs from "dayjs";
import {useMemo, useState} from "react";

const EPISODE_COUNT = 10;

/** 여행후기 */
const EpisodeComponent = ({evCd}: {evCd: string}) => {
	const goodsCd = evCd.split("-")[0];
	// const [open] = useOverlay();
	const [page, setPage] = useState(1);
	const [detailTravrvNo, setDetailTravrvNoNo] = useState<string>(null);
	const handleDetailClose = () => setDetailTravrvNoNo(null);

	/* 여행후기 데이터 */
	const reviewEpisodeFetch = useReviewEpisode(goodsCd);
	const episodeList = reviewEpisodeFetch.data?.body || [];
	const totalCount = episodeList.length || 0;
	const pageCount = EPISODE_COUNT * page;

	const list = useMemo(() => episodeList.slice(0, EPISODE_COUNT * page), [episodeList, page]);

	return (
		<>
			<style.TravelReviewWrap>
				<style.CategoryTitle $line>{`여행후기(${totalCount})`}</style.CategoryTitle>
				<style.TravelReviewList>
					{list.map(episode => {
						const {regDt, custNm, title, travrvNo} = episode;
						return (
							<li key={travrvNo} onClick={() => setDetailTravrvNoNo(travrvNo)}>
								<style.TravelReviewListItem>
									<style.TravelReviewListTitle dangerouslySetInnerHTML={{__html: title}} />
									<style.TravelReviewListInfo>{custNm ?? "- "}님</style.TravelReviewListInfo>
									<style.TravelReviewListInfo>{dayjs(regDt).format("YYYY.MM.DD")}</style.TravelReviewListInfo>
								</style.TravelReviewListItem>
							</li>
						);
					})}
				</style.TravelReviewList>
				{list.length < totalCount && (
					<style.LoadMoreBtn onClick={() => setPage(page + 1)}>
						<em>{`더보기(${pageCount}/${totalCount})`}</em>
					</style.LoadMoreBtn>
				)}
				{/* 후기가 없을 경우 */}
				{reviewEpisodeFetch.isFetched && episodeList.length === 0 && (
					<style.WriteRequest>아직 작성된 후기가 없습니다.</style.WriteRequest>
				)}
			</style.TravelReviewWrap>
			{detailTravrvNo && <EpisodePopup travrvNo={detailTravrvNo} episodeList={episodeList} close={handleDetailClose} />}
		</>
	);
};

const Episode = ({evCd}: {evCd: string}) => (
	<ErrorBoundary>
		<EpisodeComponent evCd={evCd} />
	</ErrorBoundary>
);

export default Episode;
